// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import PropTypes from 'prop-types';
import StopmonitorMap from "components/Maps/StopmonitorMap";
import { useEffect, useMemo, useState, useRef } from "react";
import { setDevicePointColour } from "utils/map";

import groupAPI from "services/api/groups";

import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import { useSoftUIController } from "hooks/context";
import StopmonitorSidebar from "components/Sidenavs/StopmonitorSidebar";
import { processGroupData } from "utils/group";
import { useQuery } from "@tanstack/react-query";

mapboxgl.accessToken = 'pk.eyJ1IjoiaGFycnltb250YW5vIiwiYSI6ImNqZWY0bDcyaTFkcGYzM28ydHFpaDJxaWcifQ.Wf7aNVePBRWZ9fMy_I81qw';

function setDeviceFeatures(device, showAdvancedDeviceLevel) {
    return {
        type: "Feature",
        properties: {
            ...device,
            access: showAdvancedDeviceLevel,
            feature_colour: setDevicePointColour(device, showAdvancedDeviceLevel)
        },
        geometry: {
            type: 'Point',
            coordinates: device.position
        }
    }
}

function StopmonitorMapView({ map, user, devices }) {

    const [controller] = useSoftUIController();
    const { deviceLayout, userPermissions } = controller;

    const [selectedDevice, setSelectedDevice] = useState(null);
    const set_padding = 300;

    const showAdvancedDeviceLevel = userPermissions.indexOf('devices-advanced:view') >= 0;


    useEffect(() => {
        if (!map.current) return;

        var bounds = new mapboxgl.LngLatBounds();

        devices.forEach(function (device) {
            var feature = setDeviceFeatures(device, showAdvancedDeviceLevel);
            bounds.extend(feature.geometry.coordinates);
        });

        if (map.current) {
            var options = {
                linear: true,
                padding: deviceLayout == 'mobile' ? set_padding / 2 : set_padding,
                pitch: 45,
                bearing: 0
            };

            const handleIdle = () => {
                map.current.fitBounds(bounds, options);
                map.current.off('idle', handleIdle);
            };

            map.current.on('idle', handleIdle);
            return () => {
                map.current.off('idle', handleIdle);
            };
        }
    }, [map, deviceLayout]);

    return (
        <SoftBox sx={{ width: '100%', height: '100%' }}>
            <StopmonitorMap {...{ map, user, devices, selectedDevice, setSelectedDevice }} />
            {selectedDevice != null && (
                <StopmonitorSidebar device={selectedDevice} {...{ map, user, setSelectedDevice }} />
            )}
        </SoftBox>
    );
}

StopmonitorMapView.propTypes = {
    map: PropTypes.object,
    user: PropTypes.object,
    devices: PropTypes.array
}

export default StopmonitorMapView;